define(function (require) {
    require("@modules/custom.ui");
    var $ = require("jquery");
    var util = require("@modules/utils");
    var dataLayerService = require("@modules/services/dataLayerService");

    var formSteps = {
        MemberInformation: "GetMemberInformation",
        AccountInformation: "GetAccountInformation",
        TermsAndPolicy: "AcceptTermsAndPolicies"
    };

    var formTypes = {
        Member: "MemberRegistration",
        Caregiver: "CaregiverRegistration"
    };

    function isValidDate(d) {
        return d instanceof Date && !isNaN(d);
    }

    function validateStep1(formType) {
        var isValid = true;
        if (formType === formTypes.Member) {
            var firstName = $("#firstName").val();
            var lastName = $("#lastName").val();
            var membershipId = $("#memberID").val();
            var dateOfBirth = $("#memberDOB").val();

            if (!firstName || $.trim(firstName) === "") {
                isValid = false;
                $("#firstNameError").show();
            }

            if (!lastName || $.trim(lastName) === "") {
                isValid = false;
                $("#LastName").show();
            }

            if (!membershipId || $.trim(membershipId) === "") {
                isValid = false;
                $("#membershipIdError").show();
            }

            if (!dateOfBirth || $.trim(dateOfBirth) === "") {
                isValid = false;
                $("#DateOfBirth").show();
            } else if (!isValidDate(new Date(document.getElementById("memberDOB").value))) {
                isValid = false;
                $("#DateOfBirthFormat").show();
            }
        } else {
            var memberBirthMonth = $("select#monthOfBirth").val();
            var memberBirthDay = $("select#dayOfBirth").val();

            if (!memberBirthMonth || $.trim(memberBirthMonth) === "") {
                isValid = false;
                $("#memberBirthMonthError").show();
            }

            if (!memberBirthDay || $.trim(memberBirthDay) === "") {
                isValid = false;
                $("#memberBirthDayError").show();
            }
        }

        return isValid;
    }

    function validateStep2(formType) {
        var isExistingRegistration = $("#checkboxCaregiver").is(":checked");
        var isAuthenticatedRegistration = $("#registration").data("authenticated") === "True";
        var isMemberRegistration = formType === formTypes.Member;
        var isProspectUser = $("#isProspectUser").val() === "True";

        var isValid = true;
        var usernameRegex = /^\S{8,}$/;
        var passwordPlaceholder = $("#password").data("placeholder-text-for-validation");

        if (isExistingRegistration || isAuthenticatedRegistration || isProspectUser) {
            var loginPassword = $("#loginPassword").val();
            if (!loginPassword || loginPassword === passwordPlaceholder || /\s/g.test(loginPassword)) {
                isValid = false;
                $("#loginPasswordError").show();
            }

            if (!isAuthenticatedRegistration) {
                var loginUsername = $("#loginUsername").val();
                if (!loginUsername || !usernameRegex.test(loginUsername)) {
                    isValid = false;
                    $("#LoginUsernameError").show();
                }
            }
        } else {
            if (isMemberRegistration) {
                var email = $("#email").val();
                var emailMaxLength = $("#new-email-maxlength").val();
                var confirmEmail = $("#confirmEmail").val();
                if (!util.isValidEmail(email)) {
                    isValid = false;
                    $("#emailError").show();
                }

                if (!util.isValidEmailLength(email, emailMaxLength)) {
                    isValid = false;
                    $("#emailMaxLengthError").show();
                }
                if (!confirmEmail || $.trim(confirmEmail) === "") {
                    isValid = false;
                    $("#confirmEmailError").show();
                }

                if (email && confirmEmail && $.trim(email) !== $.trim(confirmEmail)) {
                    isValid = false;
                    $("#emailMismatchError").show();
                    $("#confirmEmailMismatchError").show();
                }
            }

            var username = $("#username").val();
            var confirmUsername = $("#confirmUsername").val();
            var password = $("#password").val();
            var confirmPassword = $("#confirm-password").val();
            var confirmPasswordPlaceholder = $("#confirm-password").data("placeholder-text-for-validation");
            var secretQuestion = $("select#securityQuestion").val();
            var secretAnswer = $("#securityAnswer").val();

            if (!username || !usernameRegex.test(username)) {
                isValid = false;
                $("#NewUsername").show();
            }

            if (!confirmUsername || $.trim(confirmUsername) === "") {
                isValid = false;
                $("#ConfirmUserName").show();
            }

            if (username && confirmUsername && $.trim(username).toUpperCase() !== $.trim(confirmUsername).toUpperCase()) {
                isValid = false;
                $("#UsernameMismatch").show();
            }

            if (!password || password === passwordPlaceholder || !util.isValidPassword(password)) {
                isValid = false;
                $("#passwordError").show();
            }

            if (!confirmPassword || confirmPassword === confirmPasswordPlaceholder) {
                isValid = false;
                $("#confirmPasswordError").show();
            }

            if (confirmPassword && confirmPassword !== confirmPasswordPlaceholder && password && password !== passwordPlaceholder && util.showConfirmFieldError(password, confirmPassword)) {
                isValid = false;
                $("#passwordMismatchError").show();
                $("#confirmPasswordMismatchError").show();
            }

            if (!secretQuestion) {
                isValid = false;
                $("#secretQuestionError").show();
            }

            if (!secretAnswer || $.trim(secretAnswer) === "") {
                isValid = false;
                $("#secretAnswerError").show();
            }
        }

        return isValid;
    }

    function validateProspectStep() {
        var isValid = true;

        var membershipId = $("#memberID").val();
        var privacyPolicy = $("#checkboxPrivacyPolicy").is(":checked");

        if (!membershipId || $.trim(membershipId) === "") {
            isValid = false;
            $("#membershipIdError").show();
        }

        if (!privacyPolicy) {
            isValid = false;
            $("#termsAndConditionsError").show();
        }

        return isValid;
    }

    function validateStep3(formType) {
        var isValid = true;

        var privacyPolicy = $("#checkboxPrivacyPolicy").is(":checked");

        if (!privacyPolicy) {
            isValid = false;
            $("#termsAndConditionsError").show();
        }

        return isValid;
    }

    function highlightRegistrationFields() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $("span.field-validation-error:visible").each(function (index, element) {
            $(element).parent("div.form-item").addClass("is-error");
            $(element).parent(".form-item-group").parent().addClass("is-error");
            $(element).parent("div.form-item").find("span.filter-option").addClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).attr("id")).attr("aria-invalid", "true");
        });
    }

    function undoRegistrationFieldHighlights() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $("span.field-validation-error").each(function (index, element) {
            $(element).parent("div.form-item").removeClass("is-error");
            $(element).parent(".form-item-group").parent().removeClass("is-error");
            $(element).parent("div.form-item").find("span.filter-option").removeClass("is-error");
            $(element).parent().find("input").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
            $(element).parent().find("div.btn-group").find("select").attr("aria-labelledby", $(element).parent().parent().find("label").attr("id")).attr("aria-invalid", "false");
        });
    }

    function createValidationSummary() {
        $("div.validation-summary-errors").remove();
        var errorMessages = $("span.field-validation-error:visible")
            .map(function () {
                return $.trim($(this).text());
            })
            .get();

        var valueToRemove = "";

        errorMessages = $.grep(errorMessages, function (value) {
            return value !== valueToRemove;
        });

        var errorMessageCount = $(errorMessages).length;
        var $header = $("header.form-header");
        var listHtml = "";
        $header.before("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

        listHtml += "<strong class='form-error-text'>" + errorMessageCount + $(".hidden.validation-error-count").html() + "</strong>";
        listHtml += "<ul>";
        $(errorMessages).each(function (index, element) {
            listHtml += "<li>" + element + "</li>";
        });
        listHtml += "</ul>";
        $(listHtml).appendTo("#javascriptValidationSummary");
    }

    undoRegistrationFieldHighlights();
    highlightRegistrationFields();

    // field1 must have content, if field2 has content it will be compared to the field1
    function validateMatchedFields(field1Id, field2Id, missingErrorId, field1MisMatchId, field2MismatchId, validateValues) {
        var field1 = $(field1Id).val();
        var field2 = $(field2Id).val();
        var field1Placeholder = $(field1Id).data("data-placeholder-text-for-validation");

        if (!field1 || (field1Placeholder && field1 === field1Placeholder)) {
            $(missingErrorId).show();
        } else {
            $(missingErrorId).hide();
        }

        if (validateValues(field1, field2, field1Placeholder)) {
            $(field1MisMatchId).show();
            $(field2MismatchId).show();
        } else {
            $(field1MisMatchId).hide();
            $(field2MismatchId).hide();
        }
    }

    function validateCaseInsensitiveValues(field1, field2, field1Placeholder) {
        return field1 && field2 && field1 !== field1Placeholder && $.trim(field1).toUpperCase() !== $.trim(field2).toUpperCase();
    }

    function validateCaseSensitiveValues(field1, field2, field1Placeholder) {
        return field1 && field2 && field1 !== field1Placeholder && $.trim(field1) !== $.trim(field2);
    }

    $("#email").blur(function () {
        validateMatchedFields("#email", "#confirmEmail", "#emailError", "#emailMismatchError", "#confirmEmailMismatchError", validateCaseSensitiveValues);
    });
    $("#confirmEmail").blur(function () {
        validateMatchedFields("#confirmEmail", "#email", "#confirmEmailError", "#emailMismatchError", "#confirmEmailMismatchError", validateCaseSensitiveValues);
    });

    $("#username").blur(function () {
        validateMatchedFields("#username", "#confirmUsername", "#NewUsername", "#UsernameMismatch", "#UsernameMismatch", validateCaseInsensitiveValues);
    });
    $("#confirmUsername").blur(function () {
        validateMatchedFields("#confirmUsername", "#username", "#ConfirmUserName", "#UsernameMismatch", "#UsernameMismatch", validateCaseInsensitiveValues);
    });

    $("#password").blur(function () {
        validateMatchedFields("#password", "#confirm-password", "#passwordError", "#passwordMismatchError", "#confirmPasswordMismatchError", validateCaseSensitiveValues);
    });
    $("#confirm-password").blur(function () {
        validateMatchedFields("#confirm-password", "#password", "#confirmPasswordError", "#passwordMismatchError", "#confirmPasswordMismatchError", validateCaseSensitiveValues);
    });

    $("#registrationSubmit").click(function (e) {
        var isValid = true;
        var formType = $("#registration").attr("data-formType");

        undoRegistrationFieldHighlights();

        $("span.field-validation-error.form-error-hint").hide();

        var stepNumber = $("#CurrentStep").val();
        switch (stepNumber) {
            case formSteps.MemberInformation:
                isValid = validateStep1(formType);
                break;
            case formSteps.AccountInformation:
                isValid = validateStep2(formType);
                break;
            case formSteps.TermsAndPolicy:
                isValid = validateStep3(formType);
                break;
        }

        if (isValid) {
            undoRegistrationFieldHighlights();
            $("javascriptValidationSummary").remove();

            if (stepNumber === formSteps.TermsAndPolicy) {
                var isExistingRegistration = $("#registration").data("existing") === "True";
                var isAuthenticatedRegistration = $("#registration").data("authenticated") === "True";
                var memberType = formType === formTypes.Member ? "New Member" : "New Caregiver";
                if (isAuthenticatedRegistration) {
                    memberType = formType === formTypes.Member ? "Authenticated Member" : "Authenticated Caregiver";
                } else if (isExistingRegistration) {
                    memberType = formType === formTypes.Member ? "Unauthenticated Member" : "Unauthenticated Caregiver";
                }

                var registrationOption = $("#RegistrationOption").val();
                dataLayerService.pushEventToGtmDataLayer({
                    event: "gaEvent",
                    eventCategory: "Member",
                    eventAction: "Registration Option",
                    eventLabel: registrationOption
                });

                if (formType === formTypes.Member) {
                    var eDeliverySelected = $("#checkboxOnline:checked").val() === "True";
                    if (eDeliverySelected) {
                        dataLayerService.pushEventToGtmDataLayer({
                            event: "gaEvent",
                            eventCategory: "Member",
                            eventAction: "Optin-PlanMaterials",
                            eventLabel: "True"
                        });
                    }
                    dataLayerService.pushEventToGtmDataLayer({
                        event: "gaEvent",
                        eventCategory: "Member",
                        eventAction: "Registration",
                        eventLabel: "Complete"
                    });
                    var edeliverySelection = eDeliverySelected ? "online" : "mail";
                    dataLayerService.pushEventToGtmDataLayer({
                        event: "registrationSuccess",
                        memberType: memberType,
                        materialsOption: edeliverySelection
                    });

                    dataLayerService.pushEventToGtmDataLayer({
                        event: "gaEvent",
                        eventCategory: "Members",
                        eventAction: "Registration Complete",
                        eventLabel: memberType + " - " + edeliverySelection
                    });
                } else {
                    dataLayerService.pushEventToGtmDataLayer({
                        event: "registrationSuccess",
                        memberType: memberType
                    });

                    dataLayerService.pushEventToGtmDataLayer({
                        event: "gaEvent",
                        eventCategory: "Caregivers",
                        eventAction: "Registration Complete",
                        eventLabel: memberType
                    });
                }
            }
            $("#registrationSubmit").hide();
            $("#registrationSubmitDisable").show();
            $("form#registrationSubmit").submit();
        } else {
            e.preventDefault();
            highlightRegistrationFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    $("#prospectRegistrationSubmit").click(function (e) {
        var isValid = true;
        var formType = $("#registration").attr("data-formType");

        undoRegistrationFieldHighlights();

        $("span.field-validation-error.form-error-hint").hide();

        isValid = validateProspectStep(formType);

        if (isValid) {
            undoRegistrationFieldHighlights();
            $("javascriptValidationSummary").remove();

            dataLayerService.pushEventToGtmDataLayer({
                event: "registrationSuccess",
                memberType: memberType
            });

            dataLayerService.pushEventToGtmDataLayer({
                event: "gaEvent",
                eventCategory: "Caregivers",
                eventAction: "Registration Complete",
                eventLabel: memberType
            });

            $("#prospectRegistrationSubmit").hide();
            $("#prospectRegistrationSubmitDisable").show();
            $("form#prospectRegistrationSubmit").submit();
        } else {
            e.preventDefault();
            highlightRegistrationFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    //invitee reg

    $("#inviteeRegistrationSubmit").click(function (e) {
        var isValid = true;
        var formType = $("#inviteeRegistration").attr("data-formType");

        undoRegistrationFieldHighlights();

        $("span.field-validation-error.form-error-hint").hide();

        var stepNumber = $("#CurrentStep").val();
        switch (stepNumber) {
            case formSteps.MemberInformation:
                isValid = IinviteeValidateStep1(formType);
                break;
            case formSteps.AccountInformation:
                isValid = IinviteeValidateStep2(formType);
                break;
            case formSteps.TermsAndPolicy:
                isValid = IinviteeValidateStep3(formType);
                break;
        }

        if (isValid) {
            undoRegistrationFieldHighlights();
            $("javascriptValidationSummary").remove();

            if (stepNumber === formSteps.TermsAndPolicy) {
                var isExistingRegistration = $("#inviteeRegistration").data("existing") === "True";
                var isAuthenticatedRegistration = $("#inviteeRegistration").data("authenticated") === "True";
                var memberType = formType === formTypes.Member ? "New Member" : "New Caregiver";
                if (isAuthenticatedRegistration) {
                    memberType = formType === formTypes.Member ? "Authenticated Member" : "Authenticated Caregiver";
                } else if (isExistingRegistration) {
                    memberType = formType === formTypes.Member ? "Unauthenticated Member" : "Unauthenticated Caregiver";
                }

                var registrationOption = $("#RegistrationOption").val();
                dataLayerService.pushEventToGtmDataLayer({
                    event: "gaEvent",
                    eventCategory: "Member",
                    eventAction: "Registration Option",
                    eventLabel: registrationOption
                });

                if (formType === formTypes.Member) {
                    var eDeliverySelected = $("#checkboxOnline:checked").val() === "True";
                    if (eDeliverySelected) {
                        dataLayerService.pushEventToGtmDataLayer({
                            event: "gaEvent",
                            eventCategory: "Member",
                            eventAction: "Optin-PlanMaterials",
                            eventLabel: "True"
                        });
                    }
                    dataLayerService.pushEventToGtmDataLayer({
                        event: "gaEvent",
                        eventCategory: "Member",
                        eventAction: "Registration",
                        eventLabel: "Complete"
                    });
                    var edeliverySelection = eDeliverySelected ? "online" : "mail";
                    dataLayerService.pushEventToGtmDataLayer({
                        event: "registrationSuccess",
                        memberType: memberType,
                        materialsOption: edeliverySelection
                    });

                    dataLayerService.pushEventToGtmDataLayer({
                        event: "gaEvent",
                        eventCategory: "Members",
                        eventAction: "Registration Complete",
                        eventLabel: memberType + " - " + edeliverySelection
                    });
                } else {
                    dataLayerService.pushEventToGtmDataLayer({
                        event: "registrationSuccess",
                        memberType: memberType
                    });

                    dataLayerService.pushEventToGtmDataLayer({
                        event: "gaEvent",
                        eventCategory: "Caregivers",
                        eventAction: "Registration Complete",
                        eventLabel: memberType
                    });
                }
            }
            $("#inviteeRegistrationSubmit").hide();
            $("#inviteeRegistrationSubmitDisable").show();
            $("form#inviteeRegistrationSubmit").submit();
        } else {
            e.preventDefault();
            highlightRegistrationFields();
            createValidationSummary();
            $("html,body").animate({ scrollTop: 0 }, "slow");
        }
    });

    function IinviteeValidateStep1(formType) {
        var isValid = true;
        if (formType === formTypes.Member) {
            //var firstName = $("#firstName").val();
            //var lastName = $("#lastName").val();
            //var membershipId = $("#memberID").val();
            var dateOfBirth = $("#memberDOB").val();

            //if (!firstName || $.trim(firstName) === "") {
            //    isValid = false;
            //    $("#firstNameError").show();
            //}

            //if (!lastName || $.trim(lastName) === "") {
            //    isValid = false;
            //    $("#LastName").show();
            //}

            //if (!membershipId || $.trim(membershipId) === "") {
            //    isValid = false;
            //    $("#membershipIdError").show();
            //}

            if (!dateOfBirth || $.trim(dateOfBirth) === "") {
                isValid = false;
                $("#DateOfBirth").show();
            } else if (!isValidDate(new Date(document.getElementById("memberDOB").value))) {
                isValid = false;
                $("#DateOfBirthFormat").show();
            }
        } else {
            var memberBirthMonth = $("select#monthOfBirth").val();
            var memberBirthDay = $("select#dayOfBirth").val();

            if (!memberBirthMonth || $.trim(memberBirthMonth) === "") {
                isValid = false;
                $("#memberBirthMonthError").show();
            }

            if (!memberBirthDay || $.trim(memberBirthDay) === "") {
                isValid = false;
                $("#memberBirthDayError").show();
            }
        }

        return isValid;
    }

    function IinviteeValidateStep2(formType) {
        var isExistingRegistration = $("#checkboxCaregiver").is(":checked");
        var isAuthenticatedRegistration = $("#registration").data("authenticated") === "True";
        var isMemberRegistration = formType === formTypes.Member;
        var isProspectUser = $("#isProspectUser").val() === "True";

        var isValid = true;
        var usernameRegex = /^\S{8,}$/;
        var passwordPlaceholder = $("#password").data("placeholder-text-for-validation");

        if (isExistingRegistration || isAuthenticatedRegistration || isProspectUser) {
            var loginPassword = $("#loginPassword").val();
            if (!loginPassword || loginPassword === passwordPlaceholder || /\s/g.test(loginPassword)) {
                isValid = false;
                $("#loginPasswordError").show();
            }

            if (!isAuthenticatedRegistration) {
                var loginUsername = $("#loginUsername").val();
                if (!loginUsername || !usernameRegex.test(loginUsername)) {
                    isValid = false;
                    $("#LoginUsernameError").show();
                }
            }
        } else {
            if (isMemberRegistration) {
                var email = $("#email").val();
                var emailMaxLength = $("#new-email-maxlength").val();
                var confirmEmail = $("#confirmEmail").val();
                if (!util.isValidEmail(email)) {
                    isValid = false;
                    $("#emailError").show();
                }

                if (!util.isValidEmailLength(email, emailMaxLength)) {
                    isValid = false;
                    $("#emailMaxLengthError").show();
                }
                if (!confirmEmail || $.trim(confirmEmail) === "") {
                    isValid = false;
                    $("#confirmEmailError").show();
                }

                if (email && confirmEmail && $.trim(email) !== $.trim(confirmEmail)) {
                    isValid = false;
                    $("#emailMismatchError").show();
                    $("#confirmEmailMismatchError").show();
                }
            }

            var username = $("#username").val();
            var confirmUsername = $("#confirmUsername").val();
            var password = $("#password").val();
            var confirmPassword = $("#confirm-password").val();
            var confirmPasswordPlaceholder = $("#confirm-password").data("placeholder-text-for-validation");
            var secretQuestion = $("select#securityQuestion").val();
            var secretAnswer = $("#securityAnswer").val();

            if (!username || !usernameRegex.test(username)) {
                isValid = false;
                $("#NewUsername").show();
            }

            if (!confirmUsername || $.trim(confirmUsername) === "") {
                isValid = false;
                $("#ConfirmUserName").show();
            }

            if (username && confirmUsername && $.trim(username).toUpperCase() !== $.trim(confirmUsername).toUpperCase()) {
                isValid = false;
                $("#UsernameMismatch").show();
            }

            if (!password || password === passwordPlaceholder || !util.isValidPassword(password)) {
                isValid = false;
                $("#passwordError").show();
            }

            if (!confirmPassword || confirmPassword === confirmPasswordPlaceholder) {
                isValid = false;
                $("#confirmPasswordError").show();
            }

            if (confirmPassword && confirmPassword !== confirmPasswordPlaceholder && password && password !== passwordPlaceholder && util.showConfirmFieldError(password, confirmPassword)) {
                isValid = false;
                $("#passwordMismatchError").show();
                $("#confirmPasswordMismatchError").show();
            }

            if (!secretQuestion) {
                isValid = false;
                $("#secretQuestionError").show();
            }

            if (!secretAnswer || $.trim(secretAnswer) === "") {
                isValid = false;
                $("#secretAnswerError").show();
            }
        }

        return isValid;
    }

    function validateProspectStep() {
        var isValid = true;

        var membershipId = $("#memberID").val();
        var privacyPolicy = $("#checkboxPrivacyPolicy").is(":checked");

        if (!membershipId || $.trim(membershipId) === "") {
            isValid = false;
            $("#membershipIdError").show();
        }

        if (!privacyPolicy) {
            isValid = false;
            $("#termsAndConditionsError").show();
        }

        return isValid;
    }

    function IinviteeValidateStep3(formType) {
        var isValid = true;

        var privacyPolicy = $("#checkboxPrivacyPolicy").is(":checked");

        if (!privacyPolicy) {
            isValid = false;
            $("#termsAndConditionsError").show();
        }

        return isValid;
    }

});
